<template>
  <v-theme-provider :dark="dark">
    <div>
      Managing Director
      <h3
      class="text-uppercase"
      >{{countury}}</h3>

      <template v-for="({ icon, text, title: t }, i) in this[countury]">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== countury.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContactPacific',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
      countury: String,
    },

    data: () => ({
      'Francis Ho': [
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '+60 12-611-3199',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'francisho@howellcareindustries.com',
        },
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: 'LOT 833, JALAN MUSTAFFA AL-BAKRI, 36000 TELUK INTAN, PERAK DARUL RIDZUAN, MALAYSIA',
        },
      ],
    }),
  }
</script>
